export class FileData extends File {
    public objectUrl: string;

    constructor(fileBits: BlobPart[], fileName: string, objectUrl?: string) {
        super(fileBits, fileName);
        this.objectUrl = objectUrl;
    }
}